<script setup lang="ts">
import { VModal } from '@/shared/ui'
import { useInventObjectReplace } from './../model/model.ts'
import { computed, ref } from 'vue'
import { keyBy } from 'lodash'
import { useSendInventObjectReplace } from './../model/api.ts'

const model = useInventObjectReplace()
const { send } = useSendInventObjectReplace()

const valid = ref(false)

/** Вычисляем список полей объекта **/
const fields = computed(() => {
  if (!model.data) return {}

  return keyBy(model.data.invent_object_type.fields, 'id')
})

/**
 * Функция отправки данных
 */
const submitHandler = () => {
  const submitData = model.getReferenceData()

  if (submitData) {
    send(submitData).then(() => model.cleanData)
  }
}

const { isPending } = model.loadDocumentsList()
</script>

<template>
  <VModal v-model="model.openForm">
    <template #title>
      {{ $t('itf.object_replace', { name: model.object?.name || '' }) }}
    </template>

    <VForm v-if="model.data" v-model="valid" class="mt-2" @submit.prevent="submitHandler">
      <template v-for="field in model.data.fields" :key="field.id">
        <VTextField
          v-if="['string', 'number', 'date'].includes(fields[field.id].type)"
          class="mb-2"
          v-model="field.value"
          :label="fields[field.id].name"
          :type="fields[field.id].type === 'string' ? '' : fields[field.id].type"
          hide-details
        />

        <VCheckbox
          class="mb-2"
          v-if="fields[field.id].type === 'boolean'"
          v-model="field.value"
          :label="fields[field.id].name"
          density="comfortable"
        />

        <VSelect
          class="mb-2"
          v-if="fields[field.id].type === 'list'"
          v-model="field.value"
          :label="fields[field.id].name"
          :items="fields[field.id].items"
          :multiple="fields[field.id].multiple"
          item-title="name"
          item-value="name"
          hide-details
        />
      </template>

      <VDivider class="my-4" />

      <p class="mb-4">{{ $t('itf.document_replace') }}</p>

      <VFileInput
        v-model="model.infoData.document"
        :label="$t('itf.load_document')"
        :rules="model.rules.document"
      />

      <p class="text-center text_small mb-6">{{ $t('itf.or_select') }}</p>

      <VSelect
        v-model="model.infoData.document_id"
        :label="$t('itf.document_list')"
        :items="model.documentList"
        :disabled="isPending && !!model.documentList.length"
        item-value="id"
        item-title="name"
        hide-details
      />

      <VDivider class="my-4" />

      <VSelect
        v-model="model.infoData.change_type"
        :label="$t('itf.change_type')"
        :rules="model.rules.change_type"
        :items="model.changeTypes"
        item-value="id"
        item-title="name"
      />

      <VTextarea v-model="model.infoData.comment" :label="$t('itf.comment')" />

      <div class="form__btn_right">
        <VBtn type="submit">{{ $t('itf.change') }}</VBtn>
        <VBtn color="default" variant="tonal" @click.prevent="model.cleanData">{{
          $t('itf.cancel')
        }}</VBtn>
      </div>
    </VForm>
  </VModal>
</template>
